import React from "react"
import { OldIconButton } from "@kit/design/old-button"
import {
  useEditingContext,
  useElements,
  useUnsavedChanges
} from "app/forms/data/form-data"
import { Types } from "./types"
import "./custom-fields.css"
import { useCurrentUser } from "../../../hooks/use-current-user"

const newCustomField = attributes => {
  const id = Math.floor(Math.random() * 10000)
  return {
    id,
    name: id.toString(),
    group: "field",
    type: Types.Custom,
    new: true,
    ...attributes
  }
}

export const AddFieldButton = () => {
  const elements = useElements()
  const user = useCurrentUser()

  const editing = useEditingContext()

  const { setUnsavedChanges } = useUnsavedChanges()

  const handleClick = () => {
    setUnsavedChanges(true)
    const field = newCustomField({
      order: elements.inputs.length
    })
    elements.update(field)

    window.setTimeout(() => {
      const inputs = document.querySelectorAll(".formkit-input")
      const input = inputs[inputs.length - 1]
      input.click()
    }, 0)
  }

  const showAddButton = editing && !user.anonymous

  return showAddButton ? (
    <div className="forms-custom-fields w-full mb-4">
      <div className="flex space-between items-center forms-custom-fields__add">
        <div className="flex-auto block border-t border-gray-300" />
        <OldIconButton
          label="Add Custom Field"
          icon="plus-circle"
          className="inline-flex"
          onClick={handleClick}
        />
        <div className="flex-auto block border-t border-gray-300" />
      </div>
    </div>
  ) : null
}
